// extracted by mini-css-extract-plugin
export default {"root":"hO4ldk7nwKK85WIMjdR8","ifc-viewer":"g6KJc5rm46LP840WTXoO","ifcViewer":"g6KJc5rm46LP840WTXoO"};